const VUE_APP_API_URL = process.env.VUE_APP_BASE_API || `${location.origin}`
const Setting = {
    https: VUE_APP_API_URL + '/api/'
}

export default Setting
